Vue.use(PanelDataSource);

const JobsForm = {
  mixins: [vuelidate.validationMixin],
  components: {
    'term-search': TermSearch,
    'dmtk-textarea': FormTextArea,
  },
  data() {
    return {
      saved: false,
      job: {
        type: '',
        title: '',
        description: '',
        requisites: '',
        activity: {},
        location: {},
        tos: false,
      },
      employment: [
        {
          id: 'FULL_TIME',
          label: 'Tiempo completo',
        },
        {
          id: 'PART_TIME',
          label: 'Tiempo parcial',
        },
        {
          id: 'TEMPORARY',
          label: 'Temporal',
        },
        {
          id: 'PER_DIEM',
          label: 'Por día/hora',
        },
        {
          id: 'CONTRACTOR',
          label: 'Por obra',
        },
        {
          id: 'OTHER',
          label: 'Otro',
        },
      ],
      types: [
        {
          id: 'ONSITE',
          label: 'Presencial',
        },
        {
          id: 'HYBRID',
          label: 'Híbrido',
        },
        {
          id: 'ONLINE',
          label: 'Remoto',
        },
      ],
    };
  },
  computed: {
    user() {
      return domestiko.user;
    },
    canOnline() {
      return this.job.activity.online || false;
    },
  },
  props: {
    id: { default: false },
  },
  watch: {
    'job.type': function (value) {
      if (value === 'D') {
        this.user
          ? (document.location.href = '/usuarios/panel/#/perfil')
          : (document.location.href = '/usuarios/alta/');
      }
    },
  },
  created() {
    //viene id o algún parámetro
    if (this.id) {
      this.loading = true;
      this.$dmtk.jobs.read(this.id).then((data) => {
        this.job = data.job;
        this.loading = false;
      });
    } else {
      const url = new URL(location);
      if (url.searchParams.get('type') === 'p') {
        this.job.type = 'P';
      }
      if (url.searchParams.get('activity')) {
        axios
          .get('/terminos/', {
            params: { id: url.searchParams.get('activity') },
          })
          .then((result) => result.data)
          .then((term) => {
            this.job.activity = term;
          });
      }
      if (url.searchParams.get('city')) {
        axios
          .get('/terminos/', {
            params: { id: url.searchParams.get('city') },
          })
          .then((result) => result.data)
          .then((term) => {
            this.job.location = term;
          });
      }
    }

    //onbeforeunload solo para la parte pública
    if (!this.$route) {
      window.addEventListener('beforeunload', (e) => {
        //console.log(this.job.type, this.$v.$anyDirty, this.saved);
        //si no se ha tocado, se ha guardado o busca empleo, nos vamos
        if (!this.$v.$anyDirty || this.saved || this.job.type === 'D') {
          return false;
        }
        const confirmationMessage = '\\o/';
        e.returnValue = confirmationMessage; // Gecko, Trident, Chrome 34+
        return confirmationMessage; // Gecko, WebKit, Chrome <34
      });
    }
  },
  methods: {
    save() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        customAlert(
          'Ha ocurrido un error',
          'Por favor revisa los campos del formulario antes de publicar tu anuncio',
        );
        return;
      }
      const fn = this.user ? this.$dmtk.jobs.save : this.$dmtk.jobs.publish;
      fn(this.job).then((result) => {
        this.job._id = result._id;
        if (this.id) {
          UIkit.modal.alert('Datos guardados con éxito');
        } else {
          this.saved = true;
          UIkit.modal('#job-modal').show();
          dataLayer.push({
            event: 'jobs_form',
            eventCategory: 'submit',
          });
        }
      });
    },
    goHome() {
      this.user
        ? (document.location.href = '/usuarios/panel/#/empleo')
        : (document.location.href = `/${this.job.activity.slug}/${this.job.location.slug}/`);
    },
    goCreate() {
      this.user
        ? window.location.reload() //(document.location.href = '/usuarios/panel/#/empleo/nuevo')
        : (document.location.href = '/empleo/publicar');
    },
  },
  validations() {
    return {
      job: {
        email: {
          email: this.user ? true : validators.email,
          required: this.user ? true : validators.required,
        },
        employer: { required: this.user ? true : validators.required },
        type: { required: validators.required },
        title: { required: validators.required },
        description: { required: validators.required },
        employment: { required: validators.required },
        activity: { required: validators.required },
        location: { required: validators.required },
        tos: { checked: this.user ? true : validators.sameAs(() => true) },
      },
    };
  },
  template: `
    <div v-cloak>

      <div class="uk-alert uk-alert-warning" v-if="job.status && job.status === 'pending'">
        Estamos validando tu oferta, te enviaremos un correo electrónico cuando la publiquemos.
      </div>
      <div class="uk-alert uk-alert-danger" v-if="job.status && job.status === 'closed'">
        Tu oferta está desactivada, no recibirás más inscripciones.
      </div>

      <!-- h3 class="dmtk-blue uk-text-bold uk-text-uppercase">
        <span v-if="id">
        	Editar {{ job.type === 'E' ? 'oferta de empleo' : 'oferta' }}
      	</span>
        <span v-if="!id">
          Solicitar un servicio {{ job.type === 'E' ? '' : '' }}
        </span>
      </h3 -->

      <div class="uk-grid uk-grid-medium uk-child-width-1-3@m">
        <div class="uk-margin-top">
          <label>Tipo de oferta</label>
          <select
            class="uk-select"
            :class="{'-success': !$v.job.type.$invalid, 'uk-form-danger': $v.job.type.$anyError}"
            v-model="job.type">
            <option value="" disabled>Selecciona una opción</option>
            <option value="E">Oferta de empleo</option>
            <option value="P">Solicitud de presupuesto</option>
            <option value="D">Busco trabajo</option>
          </select>
          <span v-if="$v.job.type.$anyError" class="uk-text-danger">
	          Por favor indica un tipo de oferta
	        </span>
        </div>
        <div class="uk-margin-top">
          <label for="jobActivity">Actividad</label>
          <term-search
            id="jobActivity"
            scope="activity"
            taxonomy="activities"
            placeholder="¿Qué?"
            v-model="job.activity"
            @blur="$v.job.activity.$touch()"
            :css="{'-success': !$v.job.activity.$invalid, 'uk-form-danger': $v.job.activity.$anyError}"
          ></term-search>
          <span v-if="$v.job.activity.$anyError" class="uk-text-danger">
	          Por favor indica una actividad para la oferta de empleo
	        </span>
        </div>
        <div class="uk-margin-top">
          <label for="jobRegional">Localidad</label>
          <term-search
            id="jobRegional"
            scope="city"
            taxonomy="regional"
            placeholder="¿Dónde?"
            v-model="job.location"
            @blur="$v.job.location.$touch()"
            :css="{'-success': !$v.job.location.$invalid, 'uk-form-danger': $v.job.location.$anyError}"
          ></term-search>
          <span v-if="$v.job.location.$anyError" class="uk-text-danger">
	          Por favor indica una localización para la oferta de empleo
	        </span>
        </div>
      </div>

      <div class="uk-margin-top">
        <label>Título de la oferta</label>
        <input
          v-model="job.title"
          type="text" class="uk-input"
          @blur="$v.job.title.$touch()"
          :class="{'-success': !$v.job.title.$invalid, 'uk-form-danger': $v.job.title.$anyError}"
        />
        <span v-if="$v.job.title.$anyError" class="uk-text-danger">
          Por favor indica un título para la oferta de empleo
        </span>
      </div>

      <div class="uk-margin-top">
        <label>Describe la oferta lo mejor posible</label>
        <dmtk-textarea
          rows="10"
          :value="job.description"
          @input="job.description = $event"
          placeholder="Explica aquí los detalles del trabajo o servicio que necesitas"
          @blur="$v.job.description.$touch()"
          :css="{'-success': !$v.job.description.$invalid, 'uk-form-danger': $v.job.description.$anyError}"
        ></dmtk-textarea>
        <span v-if="$v.job.description.$anyError" class="uk-text-danger">
          Por favor indica una descripción para la oferta de empleo
        </span>
      </div>

      <h4 class="dmtk-blue uk-text-uppercase uk-text-bold">Características</h4>
      <div class="uk-grid uk-margin-top">
        <div class="uk-width-1-4@m uk-margin-bottom">
          <label :class="{'uk-form-danger': $v.job.employment.$anyError}">Modalidad</label>
          <ul class="uk-list">
            <li v-for="employ in employment">
              <label>
                <input type="radio" class="uk-radio" v-model="job.employment" :value="employ.id">
                {{ employ.label }}
              </label>
            </li>
          </ul>
          <span v-if="$v.job.employment.$anyError" class="uk-text-danger">
          Por favor indica la modalidad de la oferta de empleo
        </span>
        </div>
        <div class="uk-width-1-5@m uk-margin-bottom" v-if="canOnline">
          <label>Tipo</label>
          <ul class="uk-list">
            <li v-for="type in types">
              <label>
                <input type="radio" class="uk-radio" v-model="job.place" :value="type.id">
                {{ type.label }}
              </label>
            </li>
          </ul>
        </div>
        <div class="uk-width-expand">
          <label>Otros requisitos deseados</label>
          <dmtk-textarea
            rows="5"
            limit="100"
            :value="job.requirements"
            @input="job.requirements = $event"
            placeholder="Si existe algún requisito adicional escríbelo aquí."
          ></dmtk-textarea>
          <p class="uk-margin-small-top">
            Indica que requisitos adicionales se tendrán en cuenta para la oferta.
          </p>
        </div>
      </div>

      <template v-if="!user">
        <hr class="uk-margin-top">
        <h4 class="dmtk-blue uk-text-uppercase uk-text-bold uk-margin-remove">
          Para enviarte los resultados de tu anuncio
        </h4>
        <div class="uk-grid uk-grid-medium uk-child-width-1-2@m">
          <div class="uk-margin-top">
            <label>Nombre</label>
            <input
              class="uk-input"
              v-model="job.employer"
              @blur="$v.job.employer.$touch()"
              :class="{'-success': !$v.job.employer.$invalid, 'uk-form-danger': $v.job.employer.$anyError}"
              autocomplete="name"
            />
            <span v-if="$v.job.employer.$anyError" class="uk-text-danger">
	            Por favor indica tu nombre
	            </span>
          </div>
          <div class="uk-margin-top">
            <label>Correo electrónico</label>
            <input
              class="uk-input"
              type="email"
              v-model="job.email"
              @blur="$v.job.email.$touch()"
              :class="{'-success': !$v.job.email.$invalid, 'uk-form-danger': $v.job.email.$anyError}"
              autocomplete="email"
            />
            <span v-if="$v.job.email.$anyError" class="uk-text-danger">
	            Por favor indica tu correo electrónico
	            </span>
          </div>
        </div>
      </template>

      <template v-if="!user">
        <hr class="uk-margin-medium-top">
        <p class="legal -tos">
          Responsable del Tratamiento: Luis G. Valdivieso; finalidad del tratamiento: prestación del servicio;
          legitimación del tratamiento: consentimiento del interesado; destinatarios: otros usuarios del sitio web,
          colaboradores en la prestación del servicio y autoridades cuando se nos requiera legalmente; derechos:
          acceder, rectificar y suprimir los datos, así como otros derechos, como se explica en la información
          adicional.
          Derechos: correo a <a href="mailto:privacidad@domestiko.com">privacidad@domestiko.com</a>.
          Más información en la <a href="/info/politica-de-privacidad/" target="_blank">política de privacidad</a> y <a
          href="/info/politica-de-cookies/" target="_blank">cookies</a>.
        </p>
        <div class="uk-form-row">
          <input type="checkbox" class="uk-checkbox" v-model="job.tos" />
          He leído las <a href="/info/nota-legal/" target="_blank">condiciones de servicio</a>
          y la <a href="/info/politica-de-privacidad/" target="_blank">política de privacidad de Doméstiko</a>
          y acepto el tratamiento de mis datos para recibir los resultados de mi anuncio.
        </div>

        <span v-if="$v.job.tos.$anyError" class="uk-text-danger">
        	Debes aceptar las condiciones de servicio y la política de privacidad
        </span>
      </template>

      <hr class="uk-margin-medium-top">

      <div v-if="$v.$invalid" class="uk-alert uk-alert-warning uk-text-center">
        Por favor revisa los campos del formulario antes de publicar tu anuncio
      </div>

      <div class="uk-flex uk-flex-between">
        <div>
          <router-link
            v-if="$router"
            class="uk-button"
            to="/empleo"
          >
            Volver al listado
          </router-link>
        </div>
        <div>
          <button
            @click="save()"
            class="uk-button uk-button-dmtk"
          >{{ job._id ? 'Actualizar' : 'Publicar' }}
          </button>
        </div>
      </div>

      <div id="job-modal" uk-modal>
        <div class="uk-modal-dialog uk-modal-body">
          <div class="uk-modal-title">
            <span class="uk-h3">
              ¡Tu oferta se ha añadido con éxito!
            </span>
          </div>
          <div class="uk-modal-body">
            <div class="uk-text-center">
              <img src="/assets/img/drawn/publica.svg" alt="Ofertas de empleo" class="uk-img" />
            </div>
            <p v-if="user">
              Hemos recibido tu oferta y nuestros administradores la validarán lo antes posible.<br>
              Recibirás un correo cuando esté disponible para el público.<br>
              Gracias por confiar en Doméstiko.
            </p>
            <p v-else>
              Para que esté disponible al público primero tienes que validar tu cuenta.<br>
              Te hemos enviado un mensaje por correo electrónico, sigue las instrucciones.<br>
              Gracias por confiar en Doméstiko.
            </p>
            <hr />
            <div class="uk-flex uk-flex-between">
              <button class="uk-button uk-button-default uk-modal-close" @click.prevent="goHome()">
                <span v-if="user">Ver mis ofertas</span>
                <span v-else>Seguir navegando</span>
              </button>
              <button class="uk-button uk-button-primary" @click.prevent="goCreate()">
                Publicar otra oferta
              </button>
            </div>
          </div>
        </div>
      </div>

    </div>
  `,
};
